import { FormErrors } from 'redux-form';
import { isValidPhoneNumber } from '../../../../logic/phone/phone.validator';
import { clearEmptyFields } from '../../../../logic/validators/utils';
import { isRequiredValidator } from '../../../../logic/validators/validators';

export interface RegisterPhoneFormValues {
  phoneCountryCode?: string;
  phoneNumber?: string;
}

export type RegisterPhoneFormValidationErrors = FormErrors<RegisterPhoneFormValues, any>;

export const validateRegisterPhoneForm = (formValues: RegisterPhoneFormValues) => {
  const { phoneCountryCode, phoneNumber } = formValues;

  const errors: RegisterPhoneFormValidationErrors = {
    phoneNumber:
      isRequiredValidator(phoneNumber) || isValidPhoneNumber(phoneNumber, phoneCountryCode),
  };

  return clearEmptyFields(errors);
};
